<template>
  <TBadge
    :variant="computedVariant"
    size="md"
  >
    <img
      v-if="badge.IconUrl"
      :src="badge.IconUrl"
      alt=""
      class="size-4"
    >
    {{ getLocalizedText(badge.Title, locale) }}
  </TBadge>
</template>

<script setup lang="ts">
import type { BadgeVariant } from '~/components/_tailwind/badge/types'
import type { Rv } from '~/types/rv'

const props = defineProps<{
  badge: NonNullable<Rv['Badge']>
}>()

const { locale } = useI18n()

const computedVariant = computed<BadgeVariant>(() => {
  if (props.badge.Style === 'White') {
    return 'white'
  }
  return 'default'
})
</script>
